import { render, staticRenderFns } from "./CustomerInfoDialog.vue?vue&type=template&id=5bf11458&"
import script from "./CustomerInfoDialog.vue?vue&type=script&lang=js&"
export * from "./CustomerInfoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports